import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { NYDUS_NETWORK_API_BASE_URL } from '@rd/core/tokens/rd-lib.token';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { AuthState } from '../../auth/store/reducers/auth.reducer';
import { CoreState, getCoreState } from '../../store/reducers';

@Injectable()
export class NydusNetworkAuthHeaderInterceptor implements HttpInterceptor {
  constructor(
    @Inject(NYDUS_NETWORK_API_BASE_URL) private nydusNetworkUrl: string,
    private store: Store,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // This interceptor should only handle calls to Nydus Network
    const url = req.url;
    if (!url.startsWith(this.nydusNetworkUrl)) {
      return next.handle(req);
    }

    const replacedUrl = url.replace(this.nydusNetworkUrl, '');
    // We don't send token on bootstrap as this messes with the impersonate user
    // feature from Admin Panel
    if (replacedUrl.includes('bootstrap')) {
      return next.handle(req);
    }

    return this.store.select(getCoreState).pipe(
      take(1),
      map(({ auth }: CoreState) => auth),
      switchMap((auth: AuthState) => {
        if (!auth.isLoggedIn) {
          return next.handle(req);
        }

        const clonedReq = req.clone({
          headers: req.headers.set(
            'X-Access-Token',
            auth.tokenResult?.accessToken ?? '',
          ),
        });

        return next.handle(clonedReq);
      }),
    );
  }
}
